export default __webpack_public_path__ + "static/media/cycle60.1dc64676.jpeg";